import React, { useState, useEffect } from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"


import styled from 'styled-components'
import { COLORS } from '../constants/colors'
import { device } from '../constants/device';

const PageContainer = styled.div`
max-width: 1200px;
  width: 90%;
  margin: auto;
  margin-top: 5rem;
`

const Pealkiri = styled.h1`
font-size: 2em;
font-weight: 500;
text-align: left;
color:${COLORS.black};
font-family: 'Times New Roman', Times, serif;
text-transform: capitalize;
font-style: italic;
  padding-top: 1rem;
  margin-top: 0;
  padding-bottom:0.5em;

   @media ${device.laptop} {
    padding-top: 3rem;
    font-size: 3em;
  }
`

const NavWrapper = styled.nav`
  text-align: center;
  padding-top: 30px;
  padding-bottom: 50px;
  width:100%;
  display: grid;
  grid-template-columns:1fr;
  justify-content: center;
  column-gap: 1rem;
  row-gap: 0.5rem;
  border-bottom: 2px solid ${COLORS.secondary};
max-width: 1200px;
margin: auto;


   @media ${device.laptop} {
    grid-template-columns:1fr 1fr 1fr 1fr 1fr;
  }
`

const NavItem = styled(Link)`
background-color: ${COLORS.white};
color:${COLORS.third};
  text-align: center;
  border: 1px solid ${COLORS.third};
  padding: 1rem 2rem;
  width: 70%;
  margin: auto;
  text-decoration: none;
`

const ViimistlusJaTekstKonteiner = styled.div`
    border-bottom: 2px solid ${COLORS.secondary};
    margin-bottom: 4rem;
    padding-bottom: 2rem;

   @media ${device.laptop} {
column-count: 2;
 column-gap: 3rem;
  }
`

const VJTKTekst = styled.div`

   @media ${device.laptop} {
    // break-inside:inherit;
  }
`

const VJTKViimistlus = styled.div`

column-count: 4;
 column-gap: 8px;
   //padding-bottom: 1rem;
   padding-top:2rem;
  
    @media ${device.laptop} {
       border-bottom: 2px solid ${COLORS.secondary};
       padding-bottom: 2rem;
       padding-top:0;

       break-before: column;
  }
`

const GatsbyImageViimistlusKonteiner = styled.div`
display: inline-block;
height:100%;
width:100%;
margin: auto;
`

const GatsbyImageViimistlus = styled(GatsbyImage)`
display: grid;
justify-items: center;
`

const GatsbyImageViimistlusNimi = styled.p`
 line-height: 1.5em;
    height: 3em; 
    overflow: hidden;
    font-size: 0.6rem;
    text-align: center;
    font-weight: 600;

     @media ${device.laptop} {
      font-size: 0.8rem;
  }
`

const ViimistlusPiltKonteiner = styled.div`
padding-bottom: 3rem;
`

const ViimistluseLogoKonteiner = styled.div`
margin-top: 1rem;
margin-bottom: 2rem;

 @media ${device.laptop} {
   width: 25%;
  }
`

const Viimistlused = (props) => {

  const { tootjaNimi } = props.pageContext

  const [viimistlusePildid, setViimistlusePildid] = useState(null)


  const data = useStaticQuery(graphql`
    query HeaderQuery {
  allImageSharp (filter: {original: {height: {lt: 200}, width: {lt: 200}}}) {
    edges {
      node {
        gatsbyImageData(quality: 100,layout:FULL_WIDTH)
      }
    }
  }
}
  `)

  useEffect(() => {
    const viimistlused = []
    const viimistlusPildidData = data.allImageSharp.edges

    if (viimistlusPildidData) {

      for (const element of viimistlusPildidData) {
        if (element.node.gatsbyImageData.images.fallback.src.includes(`_${tootjaNimi}_VIIMISTLUS`)) {
          let pildiViimistluseString = null

          if (element.node.gatsbyImageData.images.fallback.src.includes("b9af4/")) {
            pildiViimistluseString = element.node.gatsbyImageData.images.fallback.src.substring(
              element.node.gatsbyImageData.images.fallback.src.indexOf("b9af4/") + 6,
              element.node.gatsbyImageData.images.fallback.src.indexOf("_")
            ).replaceAll('-', ' ').replace(/\s+/g, ' ');
          }

          if (element.node.gatsbyImageData.images.fallback.src.includes("01a8c/")) {
            pildiViimistluseString = element.node.gatsbyImageData.images.fallback.src.substring(
              element.node.gatsbyImageData.images.fallback.src.indexOf("01a8c/") + 6,
              element.node.gatsbyImageData.images.fallback.src.indexOf("_")
            ).replaceAll('-', ' ').replace(/\s+/g, ' ');
          }

          if (element.node.gatsbyImageData.images.fallback.src.includes("162d5/")) {
            pildiViimistluseString = element.node.gatsbyImageData.images.fallback.src.substring(
              element.node.gatsbyImageData.images.fallback.src.indexOf("162d5/") + 6,
              element.node.gatsbyImageData.images.fallback.src.indexOf("_")
            ).replaceAll('-', ' ').replace(/\s+/g, ' ');
          }

          if (element.node.gatsbyImageData.images.fallback.src.includes("191f9/")) {
            pildiViimistluseString = element.node.gatsbyImageData.images.fallback.src.substring(
              element.node.gatsbyImageData.images.fallback.src.indexOf("191f9/") + 6,
              element.node.gatsbyImageData.images.fallback.src.indexOf("_")
            ).replaceAll('-', ' ').replace(/\s+/g, ' ')
              ;
          }

          if (pildiViimistluseString.includes('%C3%A4')) {
            pildiViimistluseString = pildiViimistluseString.replace('%C3%A4', 'ä')
          }

          viimistlused.push({ ...element.node.gatsbyImageData, pildiViimistluseString })

        }
      }

    }
    setViimistlusePildid(viimistlused)
  }, [tootjaNimi, data.allImageSharp.edges])


  // Viimistluste tekst
  function viimistlusTekstAssa() {
    return tootjaNimi.toUpperCase() === 'ASSA'
  }

  function viimistlusTekstAbloy() {
    return tootjaNimi.toUpperCase() === 'ABLOY'
  }

  function viimistlusTekstKoro() {
    return tootjaNimi.toUpperCase() === 'KORO'
  }

  function viimistlusTekstMandelli() {
    return tootjaNimi.toUpperCase() === 'MANDELLI'
  }

  function viimistlusTekstOlivari() {
    return tootjaNimi.toUpperCase() === 'OLIVARI'
  }

  // Viimistluste suured pildid
  function viimistlusPiltAssa() {
    return tootjaNimi.toUpperCase() === 'ASSA'
  }

  function viimistlusPiltAbloy() {
    return tootjaNimi.toUpperCase() === 'ABLOY'
  }

  function viimistlusPiltKoro() {
    return tootjaNimi.toUpperCase() === 'KORO'
  }

  function viimistlusPiltMandelli() {
    return tootjaNimi.toUpperCase() === 'MANDELLI'
  }

  function viimistlusPiltOlivari() {
    return tootjaNimi.toUpperCase() === 'OLIVARI'
  }

  return (
    <PageContainer>
      <Pealkiri>Viimistlused</Pealkiri>
      <NavWrapper>
        <NavItem activeStyle={{
          color: '#fff',
          backgroundColor: '#73adba',
          borderColor: '#fff'
        }} to='/viimistlused/ASSA'>ASSA</NavItem>
        <NavItem activeStyle={{
          color: '#fff',
          backgroundColor: '#73adba',
          borderColor: '#fff'
        }} to='/viimistlused/ABLOY'>ABLOY</NavItem>
        <NavItem activeStyle={{
          color: '#fff',
          backgroundColor: '#73adba',
          borderColor: '#fff'
        }} to='/viimistlused/KORO'>KORO</NavItem>
        <NavItem activeStyle={{
          color: '#fff',
          backgroundColor: '#73adba',
          borderColor: '#fff'
        }} to='/viimistlused/MANDELLI'>MANDELLI</NavItem>
        <NavItem activeStyle={{
          color: '#fff',
          backgroundColor: '#73adba',
          borderColor: '#fff'
        }} to='/viimistlused/OLIVARI'>OLIVARI</NavItem>
      </NavWrapper>


      <ViimistluseLogoKonteiner>
        {viimistlusPiltAssa() && <StaticImage
          src="../images/Tootjate logod/ASSA ABLOY logo.svg"
          alt="Assa logo"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltAbloy() && <StaticImage
          src="../images/Tootjate logod/ABLOY logo.svg"
          alt="Abloy logo"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltKoro() && <StaticImage
          src="../images/Tootjate logod/KORO logo.svg"
          alt="Koro LOGO"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltMandelli() && <StaticImage
          src="../images/Tootjate logod/MANDELLI logo.svg"
          alt="Mandelli logo"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltOlivari() && <StaticImage
          src="../images/Tootjate logod/OLIVARI logo.svg"
          alt="Olivari logo"
          placeholder="blurred"
          layout="fullWidth"
        />}
      </ViimistluseLogoKonteiner>



      <ViimistlusJaTekstKonteiner>
        <VJTKTekst>
          {viimistlusTekstAssa() && <div>
            <h2>Polished Chrome</h2>
            <p>Application – For decorative use. Suitable for indoor and outdoor environments, in which corrosion can appear.
              Finish – Bright polished surface with excellent resistance to wear and tear as well as corrosion.</p>

            <h2>Brushed Chrome</h2>
            <p>Application – For decorative use. Suitable for indoor and outdoor environments, in which corrosion can appear.
              Finish - Brushed surface with excellent resistance to wear and tear as well as corrosion.</p>

            <h2>Polished Brass</h2>
            <p>Application – For decorative use in indoor environments.
              Finish – Polished surface. Not recommended in environments subjected to sea air, because this will cause fittings to oxidize and turn black.</p>

            <h2>Brushed Brass</h2>
            <p>Application – For decorative use in indoor environments.
              Finish – Brushed surface. Not recommended in environments subjected to sea air, because this will cause fittings to oxidize and turn black.</p>

            <h2>Stainless Steel</h2>
            <p>Our stainless steel lever handles, pull handles and accessories are ideal for modern public areas such as institutions and offices. The stainless steel material is highly resistant to corrosion and severe air pollutants, and is recommended for use in environments with stringent hygienic requirements. Thumbturns, toilet and cylinder accessories are available in the same design series to complement the ASSA ABLOY stainless steel lever handles.

              Application – For decorative use in all environments.
              Finish – Brushed surface. Very high resistance to wear and tear as well as corrosion.</p>

            <h2>Prion®</h2>
            <p>Application - For decorative use. Suitable for standard indoor and outdoor environments.
              Finish – Nickel-free plating suitable for users with a contact allergy. The finish has strong resistance against wear and tear as well as corrosion.</p>

            <h2>Nickel</h2>
            <p>Application – For decorative use. Suitable for standard indoor and outdoor environments.
              Finish – Bright surface with high resistance to wear and tear as well as corrosion.</p>

            <h2>Dark Oxide</h2>
            <p>Appication – For decorative use in normal  indoor environments.
              Finish – Not suitable for corrosive environments.</p>

            <h2>Addion®</h2>
            <p>Application – For decorative use. Addion is ideal for use in environments in which bacteria spread easily, such as in healthcare, schools and childcare facilities, etc.
              Finish – Addion is a unique nickel-free metallic plating that combines effective decomposition of bacteria with an excellent degree of resistance to wear and tear as well as corrosion.</p>
          </div>}
          {viimistlusTekstAbloy() && <div>
            <h2>Polished Chrome</h2>
            <p>Application – For decorative use. Suitable for indoor and outdoor environments, in which corrosion can appear.<br />
              Finish – Bright polished surface with excellent resistance to wear and tear as well as corrosion.</p>

            <h2>Satin Chrome</h2>
            <p>Application – For decorative use. Suitable for indoor and outdoor environments, in which corrosion can appear.
              Finish - Brushed surface with excellent resistance to wear and tear as well as corrosion.</p>

            <h2>Polished Brass</h2>
            <p>Application – For decorative use in indoor environments.
              Finish – Polished surface. Not recommended in environments subjected to sea air, because this will cause fittings to oxidize and turn black.</p>

            <h2>Brushed Brass</h2>
            <p>Application – For decorative use in indoor environments.
              Finish – Brushed surface. Not recommended in environments subjected to sea air, because this will cause fittings to oxidize and turn black.</p>

            <h2>White</h2>
            <p>Application – For decorative use in all environments.
              Finish – Powdercoat White (RAL 9010).</p>

            <h2>Black</h2>
            <p>Application – For decorative use in all environments.
              Finish – Powdercoat Black (RAL 9005).</p>

            <h2>Aluminum Gray</h2>
            <p>Application – For decorative use in indoor environments.
              Finish – Powdercoat Aluminum Gray (RAL 9006).</p>

            <h2>Graphite</h2>
            <p>Application – For decorative use in indoor environments.
              Finish – Powdercoat Graphite (RAL 790-M).</p>

            <h2>Stainless Steel</h2>
            <p>ASSA stainless steel lever handles, pull handles and accessories are ideal  for modern public areas suchas institutions and offices. The stainless steel material is highly resistant to corrosion and severe air pollutants, and is recommended for use in environments with stringent hygienic requirements.
              Application – For decorative use in all environments.
              Finish – Brushed surface. Very high resistance to wear and tear as well as corrosion.</p>

            <h2>Anodized Aluminum</h2>
            <p>Application – For decorative use in indoor environments.
              Finish – Powdercoat Aluminum Gray (RAL 9006), Abloy Active (infection reducing antimicrobial coating).</p>

            <h3>ABLOY ACTIVE® is an infection reducing antimicrobial coating.</h3>
          </div>}
          {viimistlusTekstKoro() && <p>Hiljem</p>}
          {viimistlusTekstMandelli() && <div>
            <p>The elegance of gold or the modern brilliance of chrome. Antique or refined satin effects. Each product is in hard and resilient brass, while a range of finishes allows then everyone to choose the most suitable handle to your own style.</p>
            <h2>Fluxcoating Vitrified</h2>
            <p>The FLUXCOATING VITRIFIED system is a coating that improves the aesthetic qualities of brass and keeps them unchanged over time. The process consists in a series of preparatory interventions of the product and the subsequent coating with special resins. The result is an incomparable resistance to atmospheric agents, shocks and abrasions. The FLUXCOATING treatment is applied to the special and exclusive MANDELLI 1953 finishes: MBR (matt burnished), MSN (matt satin nickel), AB (antique burnished), 28 (old silver).</p>
            <h2>PVD (Physical Vapor Deposition)</h2>
            <p>A further treatment applicable to MANDELLI1953 products is the PVD coating which has excellent results in abrasion resistance, corrosion resistance and sealing of the colour over time, even in outdoor and public environments. The characteristics techniques are high: resistance to sunlight stability test UNI 9337 without any variation over 1000 hours; excellent results in salt spray according to UNI standards ISO 9227 CASS and AASS resistance; high ASTM surface hardness B578-93 of 2600 ÷ 2800 HV (a normal galvanic chromium plating has hardness 800 HV); perfect adherence to the piece by passing the UNI ISO 4524-5 test; strength to acids and alkalis such as hydrochloric acid, sulfuric acid, cyanides etc. The PVD treatment is available for models marked with the dedicated symbol, only on versions rose/escutcheons and DK.</p>
          </div>}
          {viimistlusTekstOlivari() && <div>
            <h2>Galvanic finishes</h2>
            <p>The handle is protected by a layer of chrome. Galvanisation of the brass handle gives it a protective metal coat of nickel-chromium to guard against wear and corrosion.
            </p>
            <h2>PVD Finishes</h2>
            <p>With physical vapour deposition, a polished or satin-finish chrome handle is coated with an ulterior layer of metal (superfinishing) under high vacuum. Vacuum metallisation is extremely hard and durable. Nanocomposites of metal determine the specific colour of the surface and protect it from wear, scratches and aggressive substances such as humidity, sweat, salt spray, temperature swings and ultraviolet rays.</p>
            <h2>Coating</h2>
            <p>Epoxy-based powder coating, about 80 microns thick, offers a very attractive finish with great longevity, provided the product is used in accordance with the instructions and maintenance guidelines. High-intensity use and exposure to the elements can limit the product’s lifespan.</p>
          </div>}
        </VJTKTekst>

        {viimistlusePildid && <VJTKViimistlus>
          {viimistlusePildid.map(viimistlus =>
            <GatsbyImageViimistlusKonteiner>
              <GatsbyImageViimistlus image={viimistlus} src={viimistlus.images.fallback.src} alt={viimistlus.images.fallback.src} key={viimistlus.images.fallback.src} imgStyle={{ height: '100%', width: '100%' }} />
              <GatsbyImageViimistlusNimi>{viimistlus.pildiViimistluseString}</GatsbyImageViimistlusNimi>
            </GatsbyImageViimistlusKonteiner>
          )}
        </VJTKViimistlus>
        }

      </ViimistlusJaTekstKonteiner>

      <ViimistlusPiltKonteiner>
        {viimistlusPiltAssa() && <StaticImage
          src="../images/pinnaviimistlused/ASSA Pinnaviimistlused_pilt.jpg"
          alt="Assa pinnaviimistlus"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltAbloy() && <StaticImage
          src="../images/pinnaviimistlused/ABLOY Pinnaviimistlused_pilt.jpg"
          alt="Abloy pinnaviimistlus"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltKoro() && <StaticImage
          src="../images/pinnaviimistlused/KORO Pinnaviimistlused_pilt.jpg"
          alt="Koro pinnaviimistlus"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltMandelli() && <StaticImage
          src="../images/pinnaviimistlused/MANDELLI Pinnaviimistlused_pilt.jpg"
          alt="Mandelli pinnaviimistlus"
          placeholder="blurred"
          layout="fullWidth"
        />}
        {viimistlusPiltOlivari() && <StaticImage
          src="../images/pinnaviimistlused/OLIVARI Pinnaviimistlused_pilt.jpg"
          alt="Olivari pinnaviimistlus"
          placeholder="blurred"
          layout="fullWidth"
        />}
      </ViimistlusPiltKonteiner>
    </PageContainer>
  )
}

export default Viimistlused
